import React from "react";

interface IconProps {
    className?: string;
  }

const EffectsStarsIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    clipRule="evenodd"
    fillRule="evenodd"
    height="512"
    imageRendering="optimizeQuality"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    viewBox="0 0 1707 1707"
    width="512"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g id="Layer_x0020_1">
      <path d="m573 1633c-16 0-30-13-30-30 0-285-230-516-513-516-40 0-40-60 0-60 283 0 513-231 513-514 0-39 60-39 60 0 0 283 231 514 514 514 39 0 39 60 0 60-283 0-514 231-514 516 0 17-13 30-30 30zm570-810c-16 0-30-13-30-30 0-182-149-330-333-330-40 0-40-60 0-60 184 0 333-149 333-333 0-40 60-40 60 0 0 184 150 333 334 333 39 0 39 60 0 60-187 0-334 145-334 330 0 17-13 30-30 30zm237 844c-17 0-30-14-30-30 0-147-121-267-270-267-40 0-40-60 0-60 149 0 270-121 270-270 0-40 60-40 60 0 0 149 120 270 267 270 39 0 39 60 0 60-147 0-267 120-267 267 0 16-13 30-30 30z" />
    </g>
  </svg>
);

export default EffectsStarsIcon;
